import { X } from "lucide-react";
import { Dialog as BaseDialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { cn } from "../../../lib/utils";
import type { DialogProps, DialogSize } from "./types";

const SIZE_CLASSES: Record<DialogSize, string> = {
    sm: "tw-max-w-sm",
    md: "tw-max-w-md",
    lg: "tw-max-w-lg",
    xl: "tw-max-w-xl",
    "2xl": "tw-max-w-2xl",
    "3xl": "tw-max-w-3xl",
    "4xl": "tw-max-w-4xl",
    "5xl": "tw-max-w-5xl",
    full: "tw-max-w-[calc(100vw-2rem)]",
};

function Dialog({ title, open, close, children, footer, size = "md", contentClassName, headerClassName, bodyClassName, footerClassName }: DialogProps) {
    return (
        <BaseDialog open={open} onOpenChange={close}>
            <DialogContent className={cn("[&>button]:tw-hidden", SIZE_CLASSES[size], contentClassName)}>
                {title && (
                    <DialogHeader
                        className={cn(
                            "tw-flex-row tw-items-center tw-justify-between tw--mx-6 tw-px-6 tw-pb-4 tw-border-b tw-border-border",
                            headerClassName,
                        )}
                    >
                        <DialogTitle>
                            {title}
                        </DialogTitle>

                        <DialogClose className="tw-rounded-sm tw-opacity-70 tw-ring-offset-background tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-pointer-events-none">
                            <X className="tw-h-4 tw-w-4" />
                        </DialogClose>
                    </DialogHeader>
                )}
                <div className={cn("tw-space-y-4 tw-min-w-0", bodyClassName)}>
                    {children}
                </div>
                {footer && (
                    <DialogFooter className={footerClassName}>
                        {footer}
                    </DialogFooter>
                )}
            </DialogContent>
        </BaseDialog>
    );
}

export default Dialog;
